// ---------------------------------------------------------------------------
// supportConstants.js — Support (Freshdesk) module constants.
//
// The AUTHORITATIVE status/priority label maps come from the backend
// (/api/freshdesk/meta and the *Label fields on each ticket DTO). These
// constants are display helpers only — Reactstrap badge tones and icon
// choices — so the UI never re-implements the numeric→label mapping.
// ---------------------------------------------------------------------------

// Badge color per status label (Reactstrap "color" prop).
export const STATUS_TONE = {
    Open: "primary",
    Pending: "warning",
    Resolved: "success",
    Closed: "secondary",
};

// Badge color per priority label.
export const PRIORITY_TONE = {
    Low: "secondary",
    Medium: "info",
    High: "warning",
    Urgent: "danger",
};

// Fallback numeric maps — used ONLY if the backend /meta call fails, so the
// filter dropdowns still render. Kept in sync with FreshdeskMaps.cs.
export const FALLBACK_STATUSES = [
    { value: 2, label: "Open" },
    { value: 3, label: "Pending" },
    { value: 4, label: "Resolved" },
    { value: 5, label: "Closed" },
];

export const FALLBACK_PRIORITIES = [
    { value: 1, label: "Low" },
    { value: 2, label: "Medium" },
    { value: 3, label: "High" },
    { value: 4, label: "Urgent" },
];

export const statusTone = (label) => STATUS_TONE[label] || "secondary";
export const priorityTone = (label) => PRIORITY_TONE[label] || "secondary";

// Friendly message for each structured backend error code.
export const ERROR_MESSAGES = {
    unknown_account: "That support account is not available.",
    not_configured:
        "This support account is not configured yet. An administrator needs to add its API key on the server.",
    rate_limited:
        "The support system is busy right now (rate limit reached). Please try again in a moment.",
    scope_limited:
        "The configured support API key does not have permission for this action. An administrator may need to widen its agent scope.",
    not_found: "That ticket could not be found.",
    validation: "Please check the form and try again.",
    upstream: "The support system is temporarily unavailable. Please try again.",
};
